// Shown when the device is in portrait orientation. The JS
// screen.orientation.lock() call in Page.tsx handles Android Chrome;
// iOS Safari ignores it, so this overlay is the authoritative fallback.
//
// A Back button lets a user who landed here by mistake bail out
// without having to rotate — otherwise they'd be trapped on this
// screen with no way home. The button uses the SAME visual as every
// other in-game Back button (rounded-full pill, translucent black
// fill, thin white border) so affordances stay consistent across
// games, and its vertical offset respects `env(safe-area-inset-top)`
// so it never slides under the iOS notch / Android status bar.

import Icon from '@baaligames/shared-ui/components/Icon';

export default function RotatePrompt({ onExit }: { onExit?: () => void }) {
  return (
    <div className="rummy-rotate-prompt">
      {onExit && (
        <button
          type="button"
          onClick={onExit}
          aria-label="Back to home"
          title="Back to home"
          className="absolute left-3 w-10 h-10 rounded-full flex items-center justify-center bg-black/30 border border-white/15 hover:bg-black/50 active:scale-95 transition text-white"
          style={{ top: 'calc(env(safe-area-inset-top, 0px) + 12px)' }}
        >
          <Icon name="arrow_back" size={20} filled />
        </button>
      )}
      <div>
        <div className="rummy-rotate-prompt__phone" />
        <div style={{ fontSize: 16, letterSpacing: '0.12em' }}>ROTATE YOUR DEVICE</div>
        <div style={{ fontSize: 11, opacity: 0.75, marginTop: 8 }}>
          This game is designed for landscape play.
        </div>
      </div>
    </div>
  );
}
